import {
  Directive,
  Output,
  Input,
  EventEmitter,
  OnInit,
  ElementRef,
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';

@Directive({
  selector: '[appScroll]',
})
export class ChooseImageScrollDirective implements OnInit {
  @Output() scrollEvent: EventEmitter<any> = new EventEmitter();
  @Input() isLoading = false;

  private eventEmitted: boolean = false;
  private containerHeight: number = 0;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    const element = this.elementRef.nativeElement;
    this.containerHeight = element.children[0].clientHeight;
    fromEvent(element, 'scroll')
      .pipe(
        debounceTime(0),
        filter(() => !this.isLoading)
      )
      .subscribe(() => {
        if (this.containerHeight !== element.children[0].clientHeight) {
          this.containerHeight = element.children[0].clientHeight;
          this.eventEmitted = false;
        }
        if (
          !this.eventEmitted &&
          element.clientHeight + element.scrollTop * 1.1 >=
            this.containerHeight - 10
        ) {
          this.scrollEvent.emit();
          this.eventEmitted = true;
        }
      });
  }
}
